import { render, staticRenderFns } from "./ThePageMeta.vue?vue&type=template&id=1dd745b2&"
import script from "./ThePageMeta.vue?vue&type=script&lang=js&"
export * from "./ThePageMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports